import { useEffect, useState } from 'react';
import { listValueCodesRouteValueCodesGet } from '../services/api/sdk.gen';
import type { ValueCodeResponse } from '../services/api/types.gen';

let cachedOptions: ValueCodeResponse[] | null = null;
let fetchPromise: Promise<ValueCodeResponse[]> | null = null;

async function fetchOptions(): Promise<ValueCodeResponse[]> {
  if (cachedOptions) return cachedOptions;
  if (fetchPromise) return fetchPromise;

  fetchPromise = (async () => {
    try {
      const res = await listValueCodesRouteValueCodesGet({});
      const raw: unknown = res.data;
      if (!Array.isArray(raw)) {
        throw new Error('Unexpected value codes payload shape');
      }
      cachedOptions = raw as ValueCodeResponse[];
      return cachedOptions;
    } catch (err) {
      console.error('Failed to load value codes', err);
      fetchPromise = null;
      return [];
    }
  })();

  return fetchPromise;
}

/**
 * Fetches the NUBC value-code reference list once per session and caches it.
 * Worksheet editors mock THIS hook in their test suites (do not fetch inside
 * ValueCodesField directly — the editors' closed services/api mock factories
 * would silently pin the field to its fallback).
 */
export function useValueCodeOptions() {
  const [options, setOptions] = useState<ValueCodeResponse[]>(
    cachedOptions ?? []
  );
  const [loading, setLoading] = useState(!cachedOptions);

  useEffect(() => {
    let cancelled = false;
    fetchOptions().then(data => {
      if (!cancelled) {
        setOptions(data);
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { options, loading };
}
